<template>
  <div class="cargo-pop-select-input">
    <el-input no="displayName" :style="`width: ${inputWidth};`" :value="displayName ? displayName : eventName" @click.native="dialogVisible=true" />
    <el-dialog
      no="selectDialog"
      :title="title"
      :visible.sync="dialogVisible"
      width="1160px"
      append-to-body
    >
      <div class="select-dialog" style="display: flex; margin: 10px">
        <span style="align-self:center; margin-right: 5px">{{ filterLabel }}  </span>
        <el-input v-model="searchValue" no="searchValue" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" @input="selectedBak = displayName" />

        <span v-if="showOffice" style="align-self:center; margin-left: 15px; margin-right: 5px">{{ $t('CargoMsg.Cargo_SelectBranch') }}  </span>
        <el-select v-if="showOffice" ref="select" v-model="branchIds" multiple filterable style="width: 218px" @visible-change="onVisibleChange">
          <el-option :value="0" :label="$t('Message.All')" />
          <el-option
            v-for="office in currentOfficeList"
            :key="office.uuid"
            :value="office.officeId"
            :label="office.code"
          />
        </el-select>
        <el-button v-if="showBranchSelectBtn" size="mini" type="primary" style="margin-left: 5px;" @click="showBranchSelectDialog">...</el-button>

      </div>
      <div class="grid">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :grid-options="gridOptions"
          :row-data="filterData"
          :show-side-bar="false"
          style="height:100%;min-height: 400px;"
        />
      </div>
      <template slot="footer">
        <div style="display: flex;text-align: left;">
          <span class="blue">{{ $t('CargoMsg.Cargo_CurrentSelection') }}:</span>
          <div style="flex: 1;height: 28px;overflow-y: auto;text-align: left;word-break: break-word;margin-left: 5px">
            {{ displayName ? displayName : eventName }}
          </div>
        </div>
        <div>
          <el-button no="confirm" type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button no="reset" @click="onReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
          <el-button no="cancel" @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </template>
      <!-- 分公司选择弹窗 -->
      <branch-select-dialog :append-to-body="true" :visible.sync="branchSelectDialog.visible" :value="branchSelectDialog.value" :office-list="currentOfficeList" @callback="branchSelectDialog.callback" />
    </el-dialog>
  </div>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import lang from '@/lang'
import { getUserInfo } from '@/utils/auth'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'

export default {
  name: 'SelectDialog',
  components: { CargoAgGrid, BranchSelectDialog },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    columnDefs: {
      type: Array,
      default: () => []
    },
    rowData: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: () => ''
    },
    eventName: {
      type: String,
      default: () => ''
    },
    filterKeys: {
      type: Array,
      default: () => ['code', 'englishName', 'chineseName']
    },
    displayNameField: {
      type: String,
      default: () => 'fieldName'
    },
    inputWidth: {
      type: String,
      default: () => '390px'
    },
    filterLabel: {
      type: String,
      default: () => lang.t('CargoMsg.Cargo_Query')
    },
    showOffice: {
      type: Boolean,
      default: () => false
    },
    showBranchSelectBtn: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      gridOptions: {
        rowSelection: 'single',
        onRowClicked: this.onRowClick
      },
      displayName: '',
      selectedData: null,
      selectedBak: '',
      branchIds: [],
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {}
      },
      branchIdsIsEdit: false
    }
  },
  computed: {
    filterData() {
      const { searchValue, rowData, branchIds } = this
      if (!searchValue.trim()) {
        if (branchIds && branchIds.length > 0 && !branchIds.includes(0)) {
          return rowData.filter(row => branchIds.includes(row.officeId))
        }
        return rowData
      } else {
        const filterKeys = this.filterKeys
        return rowData.filter(row => {
          if (branchIds && branchIds.length > 0 && !branchIds.includes(0)) {
            if (!branchIds.includes(row.officeId)) {
              return false
            }
          }
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && row[key].toLowerCase().indexOf(searchValue.trim().toLowerCase()) !== -1) return true
          }
        })
      }
    },
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (this.value) {
        const index = this.rowData.findIndex(item => item.uuid === this.value)
        if (index > -1) {
          const data = this.rowData[index]
          this.$nextTick(() => {
            setTimeout(() => {
              const api = this.gridOptions.api
              api.setFocusedCell(index, api.columnController.getAllDisplayedColumns()[0])
              this.selectedData = data
              this.displayName = data[this.displayNameField]
            }, 0)
          })
        } else {
          if (this.gridOptions.api) {
            this.gridOptions.api.clearFocusedCell()
          }
          this.selectedData = { uuid: this.value }
          this.displayName = ''
        }
      } else {
        this.searchValue = ''
        this.branchIds = []
        this.selectedData = null
        if (this.gridOptions.api) {
          this.gridOptions.api.clearFocusedCell()
        }
      }
      if (!newVal) {
        return
      }
    },
    // filterData() {
    //   this.$nextTick(() => {
    //     // this.displayName = this.selectedBak
    //     console.log("filterData, displayName:", this.displayName)
    //   })
    // },
    branchIds() {
      this.$nextTick(() => {
        this.onVisibleChange(this.branchIdsIsEdit)
      })
    }
  },
  methods: {
    onRowClick(event) {
      const data = event.data
      this.selectedData = data
      this.displayName = data[this.displayNameField]
      this.$emit('selected', this.selectedData ? this.selectedData : '')
    },
    onSave() {
      this.$emit('change', this.selectedData ? this.selectedData : '')
      this.dialogVisible = false
    },
    onReset() {
      this.selectedBak = ' '
      this.selectedData = null
      this.displayName = ' '
      this.searchValue = ''
      this.branchIds = []
      if (this.gridOptions.api) {
        this.gridOptions.api.clearFocusedCell()
      }
    },
    handleClose() {
      this.onReset()
      this.dialogVisible = false
    },
    // 分公司 查询项相关
    onVisibleChange(isEdit) {
      this.branchIdsIsEdit = isEdit
      this.convertMultiSelectedToText()
    },
    convertMultiSelectedToText() {
      this.$nextTick(() => {
        const select = this.$refs.select
        if (!select) {
          return
        }
        const tags = select.$el.querySelector('.el-select__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let input = null
        for (const child of tags.childNodes) {
          if (!child.classList) {
            continue
          }
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-select__input')) {
            input = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (input) {
            input.style.display = ''
            input.value = ''
            input.setAttribute('placeholder', this.getMultiDisplay(input.offsetWidth))
            input.focus()
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getMultiDisplay(customDisplay.offsetWidth)
          customDisplay.setAttribute('title', this.getMultiDisplay())
          if (input) {
            input.style.display = 'none'
          }
        }
      })
    },
    getMultiDisplay(width) {
      const texts = []
      for (const branchId of this.branchIds) {
        if (branchId === 0) {
          texts.push(this.$t('Message.All'))
          continue
        }
        const office = this.currentOfficeList.find(p => p.officeId === branchId)
        if (office) {
          texts.push(office.code)
        }
      }
      if (typeof width === 'number') {
        return this.getTextEllipsis(texts.join(','), width, 12, 9)
      }
      return texts.join(',')
    },
    getTextEllipsis(text, width, fontSize = 12, paddingWidth = 25) {
      if (width > 0) {
        const textWidth = this.getTextWidth(text, fontSize, paddingWidth)
        if (textWidth > width) {
          for (let i = 3; i <= text.length; ++i) {
            const subText = text.substring(0, i)
            const subTextWidth = this.getTextWidth(subText, fontSize, paddingWidth)
            if (subTextWidth > width) {
              return text.substring(0, i - 2) + '...'
            }
          }
        }
      }
      return text
    },
    getTextWidth(text, fontSize, paddingWidth) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = `normal ${fontSize}px sans-serif`
      return ctx.measureText(text).width + paddingWidth
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = this.branchIds
      this.branchSelectDialog.callback = val => {
        this.branchIds = val
        // this.changeOfficeHandler()
      }
      this.branchSelectDialog.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-pop-select-input{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    height: 460px;
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}
.select-dialog::v-deep {
  .el-select {
    .el-select__tags {
      .custom-display {
        width: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        margin-left: 9px;
      }
      .el-tag--info {
        display: none;
      }
      .el-select__input {
        margin-left: 9px;
        font-size: 12px;
      }
    }
  }
}

</style>
